import mainViewMixin from './mainViewMixin';
export default {
  name: 'ViewNiotaClassicDataSources',
  mixins: [mainViewMixin],
  data: function () {
    return {};
  },
  computed: {
    headerBG() {
      return './img/consumer.png';
    },
    isSuperSystemAdmin() {
      return this.permissions['super.system.manage'];
    },
    dataSourceButtons() {
      return this.buttons.map(button => {
        return {
          ...button,
          valid: this.isSuperSystemAdmin === true
        };
      });
    }
  }
};